(() => {
  const bindings = new WeakMap();
  let frame;
  let sequence = 0;
  const scan = () => {
    document.querySelectorAll('main .zs-org-smallbags').forEach((root) => {
      const track = root.querySelector('.zs-org-smallbags__list');
      const heading = root.querySelector('h2');
      if (!track || !heading) return;
      const existing = bindings.get(root);
      if (existing?.track === track) {
        existing.update();
        return;
      }
      existing?.observer.disconnect();
      existing?.nav.remove();
      let header = root.querySelector('.zs-pdp-carousel-header');
      if (!header) {
        header = document.createElement('div');
        header.className = 'zs-pdp-carousel-header';
        heading.before(header);
        header.append(heading);
      }
      if (!track.id) track.id = `zs-pdp-carousel-${++sequence}`;
      const nav = document.createElement('div');
      nav.className = 'zs-pdp-carousel-nav';
      const buttons = [-1, 1].map((step) => {
        const button = document.createElement('button');
        button.type = 'button';
        button.setAttribute('aria-label', step < 0 ? 'Föregående produkter' : 'Nästa produkter');
        button.setAttribute('aria-controls', track.id);
        button.innerHTML = `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" aria-hidden="true"><path d="${step < 0 ? 'm14 6-6 6 6 6' : 'm10 6 6 6-6 6'}"/></svg>`;
        button.addEventListener('click', () => {
          const card = Array.from(track.children).find((item) => !item.hidden);
          if (!card) return;
          const gap = parseFloat(getComputedStyle(track).columnGap) || 0;
          track.scrollBy({left: step * (card.getBoundingClientRect().width + gap), behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'});
        });
        nav.append(button);
        return button;
      });
      header.append(nav);
      const update = () => {
        const max = track.scrollWidth - track.clientWidth;
        const hidden = max < 2;
        if (nav.hidden !== hidden) nav.hidden = hidden;
        buttons[0].disabled = track.scrollLeft < 2;
        buttons[1].disabled = track.scrollLeft >= max - 2;
      };
      const observer = new ResizeObserver(update);
      observer.observe(track);
      track.addEventListener('scroll', update, {passive:true});
      bindings.set(root, {track, nav, observer, update});
      update();
    });
  };
  const schedule = () => {
    cancelAnimationFrame(frame);
    frame = requestAnimationFrame(scan);
  };
  new MutationObserver(schedule).observe(document.body, {childList:true, subtree:true, attributes:true, attributeFilter:['hidden']});
  document.addEventListener('on:variant:change', schedule);
  scan();
})();
